import { type FC, useState } from "react";

import { annotate } from "../utils";
import { useScanner, type ScanResult } from "../Scanner";

export const ScannerTestPage:FC = () => {
  const [scanResult, setScanResult] = useState(annotate<ScanResult | null | "initial">("initial"));
  const { startScanner } = useScanner({
    onScanResult: setScanResult,
  });

  return <div>
    <button type="button" onClick={() => { startScanner(); }}>Start</button>
    <p>
      {(scanResult === "initial") ? "You haven't scanned anything yet" : (scanResult == null) ? "Scan cancelled or failed" : `Scanned a ${scanResult.format} with contents '${scanResult.text}'`}
    </p>
  </div>
};
